import React from 'react';
import RefreshIcon from "../../assets/RefreshIcon";
import SilverButton from "./SilverButton";
import Translate from "../../components/Translate";


const ResetButton = ({ onClick, alt = 'Export', height = 40, width = 40 , children, variant = 'default', disabled = false }) => {
    return (
        <SilverButton
            width={width}
            height={height}
            onClick={onClick}
            variant={variant}
            disabled={disabled}
        >
            <div style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'transparent',
                height: '100%',
                width: '100%',
                fontSize: '14px',
                color: disabled ? '#aaaaaa' : '#043e5c',
            }}>
                <RefreshIcon
                    width={20}
                    height={20}
                />
                <Translate text={'resetFilters'} />
                {children}
            </div>
        </SilverButton>
    );
};

export default ResetButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/ResetButton.jsx